import React from 'react';
import './Branches.css';

const Branches = () => {
  const branches = [
    {
      name: "Tirupur - Sheriff Colony",
      address: "Kurnji Nagar Extn.,\nSheriff Colony,\nTirupur - 641604\nTamil Nadu, India",
      phone: "+91 9629 137 666"
    },
    {
      name: "Tirupur - Gandhi Nagar",
      address: "60 Feet Road,\nGandhi Nagar,\nTirupur - 641603\nTamil Nadu, India",
      phone: "+91 9629 137 666"
    },
    {
      name: "Coimbatore - Ramantahpuram",
      address: "Opposite to Alvernia School,\n78, Kongu Nagar, Ramanathpuram,\nCoimbatore - 641045\nTamil Nadu, India",
      phone: "+91 95 14 14 74 99"
    },
    {
      name: "Coimbatore - Kalapatti",
      address: "Kovai Estate,\nNehru Nagar,\nCoimbatore - 641048\nTamil Nadu, India",
      phone: "+91 95 14 14 74 99"
    }
  ];

  return (
    <section id="branches" style={{ background: 'var(--light-grey)' }}>
      <div className="section-header">
        <h2 className="section-title">Our Branches</h2>
        <p className="section-subtitle">
          Find us across Tirupur and Coimbatore
        </p>
      </div>
      <div className="branches-grid">
        {branches.map((branch, index) => (
          <div key={index} className="branch-card">
            <h3 className="branch-name">{branch.name}</h3>
            <p className="branch-address">
              {branch.address.split('\n').map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}<br />
                </React.Fragment>
              ))}
              <strong>Phone:</strong> {branch.phone}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Branches;
